/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type { ModelListItem } from "parog-web/components/model-list";

interface Signature {
  Args: {
    changeset: EmberChangeset;
    item: ModelListItem;
  };
}

export default class TreatmentHistoryEditionFormChemotherapyOncoLungCancerComponent extends Component<Signature> {
  get chemotherapyProtocols() {
    return [
      "3-fec-100-3-taxotere",
      "3-fec-100-9-weekly-taxol",
      "3-fec-100-12",
      "4-tc",
      "12-weekly-taxol",
      "12-taxol-3-ec",
      "3-ec-9-weekly-taxol",
      "4-ec-9-taxol",
      "6-ec-9-taxol",
      "6-taxotere"
    ];
  }

  get chemotherapies() {
    return this.args.changeset.get("chemotherapies");
  }

  @action
  onChangesetUpdate(changeset: EmberChangeset) {
    changeset.execute();
    this.setAsDirty();
  }

  setAsDirty() {
    this.args.changeset.set("chemotherapies", [].concat(this.chemotherapies));
  }
}
